import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { authSlice } from './auth';
import {prospectsSlice} from './prospects'
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage
};

const rootReducer = combineReducers({
    decoCharpenteAuthentication: authSlice.reducer,
    decoCharpenteProspect: prospectsSlice.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        })
});

export type AppStore = typeof store;

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
